import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { sendInvitesUiActions } from '@actions';
import { RoutePath } from '@constants/routes';
import { isSurveySendable } from '@constants/surveys';

export function useClickSendSurveys() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const companies = useSelector(state => state.account?.account?.companies);

    const surveyExists = useMemo(() => {
        return (
            companies
                ?.map(company => company.surveys)
                ?.flat()
                .filter(isSurveySendable).length > 0
        );
    }, [companies]);

    const onClickSendSurveys = () => {
        if (!surveyExists) {
            navigate(RoutePath.SurveysTemplates);
        } else {
            dispatch(sendInvitesUiActions.setOpen(true));
        }
    };

    return { surveyExists, onClickSendSurveys };
}
